<template>
	<div>
		<slot name="default" :label="clientModel.__label" :value="item">
			<div v-if="__isIcon">
				<l-tooltip left>
					<template slot="activator" slot-scope="{ on, attrs }">
						<v-icon v-bind="{ ...$attrs, ...attrs }" v-on="{ ...$listeners, ...on }" :color="$_.get(item, 'iconColor')">
							{{ $_.get(item, 'iconName') }}</v-icon
						>
					</template>
					<span>{{ $_.get(item, 'iconToolTipText') }}</span>
				</l-tooltip>
			</div>
			<div v-else-if="$scopedSlots.selection">
				<!-- ToDo: Improve below filter.map.includes -->
				<div
					v-for="(singleItem, index) of $attrs.items.filter((item) =>
						$_.get(value, __path)
							.map((mapItem) => (typeof mapItem === 'object' ? mapItem._id : mapItem))
							.includes(item._id)
					)"
					:key="index"
				>
					<slot name="selection" v-bind="{ item: singleItem, parent: { itemText: $attrs.itemText } }" />
				</div>
			</div>
			<div v-else>
				<div>{{ item }}</div>
			</div>
		</slot>
	</div>
</template>

<script>
import { _BaseModel } from '@/plugins/clientModels/models/helpers/_BaseModel';
import i18n from '@/plugins/i18n';
import dayjs from 'dayjs';
import LTooltip from '@/components/base/LTooltip.vue';

export default {
	name: 'LRender',
	components: { LTooltip },
	i18n,
	props: {
		value: {
			type: _BaseModel,
			required: true,
		},
		__path: {
			type: String,
			required: true,
		},
		__model: {
			type: _BaseModel,
			required: false,
		},
		__label: {
			type: String,
			required: false,
		},
		__get: {
			required: false,
		},
		__isDate: {
			type: Boolean,
			default: false,
		},
		__isDateTime: {
			type: Boolean,
			default: false,
		},
		__isTime: {
			type: Boolean,
			default: false,
		},
		__isIcon: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		clientModel: {},
	}),
	computed: {
		item() {
			const value = this.$_.get(this.value, this.__path);
			let get = this.$_.get(this, 'clientModel.__get');

			if (!get) {
				let isDate = this.$_.get(this.clientModel.pathOptions, '__isDate');
				let isDateTime = this.$_.get(this.clientModel.pathOptions, '__isDateTime');
				let isTime = this.$_.get(this.clientModel.pathOptions, '__isTime');
				if (this.__isDate) {
					isDate = true;
					isDateTime = false;
					isTime = false;
				}
				if (this.__isDateTime) {
					isDate = false;
					isDateTime = true;
					isTime = false;
				}
				if (this.__isTime) {
					isDate = false;
					isDateTime = false;
					isTime = true;
				}

				if (isDate) get = (value) => dayjs(value).format(this.$t('$global.date.normal'));
				else if (isDateTime) get = (value) => dayjs(value).format(this.$t('$global.dateTime.normal'));
				else if (isTime) get = (value) => dayjs(value).format(this.$t('$global.time.normal'));
			}

			const formatReturn = (value) => {
				if (this.$attrs.itemText && typeof this.$attrs.itemText === 'string') {
					return this.$_.get(value, this.$attrs.itemText);
				} else if (this.$attrs.itemText && typeof this.$attrs.itemText === 'function') {
					let formatFromValue = value;
					if (this.$attrs.itemValue && this.$attrs.items) {
						formatFromValue = this.$attrs.items.find((element) =>
							this.$_.isEqual(this.$_.get(element, this.$attrs.itemValue), value)
						);
					}
					return this.$attrs.itemText(formatFromValue);
				} else if (get) {
					return get(value);
				}
				return value;
			};

			if (Array.isArray(value)) {
				let out = value.map(formatReturn).sort();
				if (!this.$scopedSlots.selection) {
					out = out.join(', ');
				}
				return out;
			} else {
				return formatReturn(value);
			}
		},
	},
	methods: {},
	created() {
		let model = null;
		if (this.__model) model = this.__model;
		else if (this.value && this.value instanceof _BaseModel) model = this.value.constructor;
		// else throw new Error('Neither "model" prop set, nor value provided to derive model from.')

		let pathOptions = null;
		if (model) pathOptions = model.getPath(this.__path);
		// if (!pathOptions) console.log('No pathOptions for path ', this.__path);
		// todo: clientModelGenerator must create pathOptions for getters as well, then the below may be checked
		// if (!pathOptions) throw new Error(`Could not get pathOptions for "${this.__path}"`);
		let label = this.$_.get(pathOptions, '__bind.label', 'no label set');
		const itemText = this.$_.get(pathOptions, '__bind.itemText');
		let get = this.$_.get(pathOptions, '__get');

		if (this.__label) label = this.__label;

		// todo: the below should also run for backend string functions
		// todo: run functions provided as string
		// todo: why the code below?
		const getProp = this.__get;
		if (getProp) {
			if (typeof getProp === 'function') get = getProp;
			else if (typeof getProp === 'string')
				get = () => this.$_.get(this.value, (this.__path ? this.__path + '.' : '') + getProp);
			else throw new Error('Unkown "__get" prop.');
		} else if (itemText) get = (value) => this.$_.get(value, itemText);

		// todo: label is not yet used
		this.clientModel = {
			__get: get,
			__label: label,
			pathOptions,
		};
	},
};
</script>
